import { PredefinedShape } from '@common/models';
import { TypedUseQueryHookResult } from '@reduxjs/toolkit/dist/query/react';

import { AxiosBaseQueryFunction } from '../../api/axiosBaseQuery';
import {
    PredefinedShapesParams,
    useFetchPredefinedShapesQuery,
} from '../../api/static-content-api/predefined-shapes-api/predefinedShapesService';

type usePredefinedShapesReturn = TypedUseQueryHookResult<
    PredefinedShape[],
    PredefinedShapesParams,
    AxiosBaseQueryFunction
> & {
    predefinedShapes: PredefinedShape[];
};

const emptyArray = [] satisfies PredefinedShape[];

export const usePredefinedShapes = (): usePredefinedShapesReturn => {
    const { predefinedShapes, ...rest } = useFetchPredefinedShapesQuery(undefined, {
        refetchOnFocus: false,
        refetchOnReconnect: false,
        selectFromResult: (result) => {
            return {
                predefinedShapes: result.isError ? emptyArray : result.data ?? emptyArray,
                ...result,
            };
        },
    });

    return {
        predefinedShapes,
        ...rest,
    };
};
